// Map all env vars to JS vars in one file to avoid having `process` everywhere

const ENV = {
  APPINSIGHTS_CONNECTIONSTRING: process.env.ConnectionString,
  APPINSIGHTS_ENABLED: process.env.InstrumentationEnabled === 'true',

  SHIPBOB_UI_URL: process.env.SHIPBOB_UI_URL,
  MFE_ROOT_ROUTE: process.env.MFE_ROOT_ROUTE,
  DEV_ROOT_ELEMENT_SELECTOR: process.env.DEV_ROOT_ELEMENT_SELECTOR,

  AUTHENTICATION_AUTHORITY: process.env.AUTHENTICATION_AUTHORITY,
  CLIENT_ID: process.env.CLIENT_ID,
  CLIENT_SCOPE: process.env.CLIENT_SCOPE,
  ROOT_ELEMENT_CONTAINER: process.env.ROOT_ELEMENT_CONTAINER,

  ENABLE_TOKEN_DELEGATION: process.env.ENABLE_TOKEN_DELEGATION === 'true',

  SUPPORT_ARTICULE_URL: process.env.SUPPORT_ARTICULE_URL,
  HOW_TO_VIDEO_URL: process.env.HOW_TO_VIDEO_URL,
  PACKING_SLIP_ENDPOINT: process.env.PACKING_SLIP_ENDPOINT,
  FULFILLMENT_CUSTOMIZATION_ENDPOINT: process.env.FULFILLMENT_CUSTOMIZATION_ENDPOINT,
  ATTACHMENT_ENDPOINT: process.env.ATTACHMENT_ENDPOINT,
  STORAGE_BLOB_KEY: process.env.STORAGE_BLOB_KEY,
  ENABLE_MULTIPLE_PS_SETTINGS: process.env.ENABLE_MULTIPLE_PS_SETTINGS === 'true',
  ENABLE_RICHTEXT_INPUT: process.env.ENABLE_RICHTEXT_INPUT === 'true',
  SUPPORT_EMAIL: process.env.SUPPORT_EMAIL,
  FRONT_END_APP_SETTINGS_API_URL: process.env.FRONT_END_APP_SETTINGS_API_URL,
};

export {
  ENV,
};
